import React from 'react'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import RushCart from '../../../utils/CommonFunctionality/Cart/rushCart'

const RushPass = (props) => {
    return (
        <>
            <SEOTAG page="RushPass" />
            <Layout props={props}>
                <div className="lq-db-table">
                    <RushCart props={props} />
                </div>
            </Layout>
        </>
    )
}

export default RushPass
